import { AuthRepository } from '../repositories/AuthRepository';


export class SendOtp {
  constructor(private repository: AuthRepository) {}

  execute(params: SendOtpParams): Promise<void> {
    return this.repository.sendOtp(params.email, params.type);
  }
}


export class SendOtpParams {
  constructor(public email: string, public type:string) {}
}
